/* assets/estilo-index.js — tokenless estilo lookup via native storefront
   metafield filtering. No Storefront API, no tokens. Identical on all stores. */
window.EstiloIndex = (function () {
  const BASE = "/collections/all";
  const MF = "filter.p.m.custom.estilo";

  // Resolve the search results section id from the current page, so the
  // store-specific "template--<number>__main" id is never hardcoded.
  function sectionId() {
    // main results section on the search template
    const el =
      document.querySelector('[id^="shopify-section-"][id$="__main"]') ||
      document.querySelector('[id^="shopify-section-"][id*="search"]') ||
      document.getElementById("product-grid")?.closest('[id^="shopify-section-"]');
    return el ? el.id.replace(/^shopify-section-/, "") : null;
  }

  async function fetchFiltered(value, withSection) {
    let url = `${BASE}?${MF}=${encodeURIComponent(value)}`;
    if (withSection) {
      const sid = sectionId();
      if (sid) url += `&section_id=${encodeURIComponent(sid)}`;
    }
    const res = await fetch(url);
    if (!res.ok) throw new Error(res.status);
    return res.text();
  }

  function cardsFrom(html) {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return [...doc.querySelectorAll(".product-card")];
  }

  function handleOf(card) {
    const a = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
    return a?.getAttribute("href")?.match(/\/products\/([^/?#]+)/)?.[1] || null;
  }

  // Stored estilo values are uppercase in this catalog; try uppercase first,
  // then the raw and lowercase forms. First non-empty result wins.
  function casings(term) {
    const q = String(term || "").trim();
    return q ? [...new Set([q.toUpperCase(), q, q.toLowerCase()])] : [];
  }

  async function renderCards(term) {
    for (const val of casings(term)) {
      try {
        // plain collection HTML (no section_id) — same source match() uses,
        // which is confirmed to contain .product-card on every store
        const cards = cardsFrom(await fetchFiltered(val, false));
        if (cards.length) return cards.map(c => c.outerHTML).join("");
      } catch (e) {}
    }
    return "";
  }

  async function match(term) {
    for (const val of casings(term)) {
      try {
        const cards = cardsFrom(await fetchFiltered(val, false));
        if (cards.length) return cards.map(handleOf).filter(Boolean);
      } catch (e) {}
    }
    return [];
  }

  function handlesIn(container) {
    return new Set(
      [...container.querySelectorAll('a[href*="/products/"]')]
        .map(a => a.getAttribute("href").match(/\/products\/([^/?#]+)/)?.[1])
        .filter(Boolean)
    );
  }

  return { match, renderCards, handlesIn };
})();